import { createFileRoute, Outlet } from '@tanstack/react-router';
import { ImagePage } from '@/layouts/ImagePage';

export const Route = createFileRoute('/_auth')({
  component: AuthLayout,
});

function AuthLayout() {
  return (
    <ImagePage>
      <Outlet />
    </ImagePage>
  );
}
